import digital_human_setting from "@/utils/digital_human";
import {
  BOT_BACKGROUND,
  DIGITAL_HUMAN_LOADING,
  DIGITAL_HUMAN_SETTING,
  HYGEN_PEER_CONNECTION,
  HYGEN_RENDER_ID,
  HYGEN_SESSION_ID,
  HYGEN_SESSION_INFO,
  HYGEN_SESSION_ERROR,
  SESSION_INITIALIZED_SUCCESSFULLY,
  RESET_HYGEN_STORE
} from "./constants";
import { DigitalHumanSetting, DigitalHumanState } from "./interfaces";
import { IApp } from "@/interfaces";

export default {
  [RESET_HYGEN_STORE]: (state: DigitalHumanState): void => {
    state.loading = false;
    state.bot_background = true;
    state.bot_setting = digital_human_setting[IApp.Portals.AI_LAWYER];
    state.hygen_peer_connection = null;
    state.hygen_render_id = 1;
    state.hygen_session_id = null;
    state.hygen_session_info = null;
    state.hygen_session_error = "";
    state.session_initialized_successfully = false;
  },
  [DIGITAL_HUMAN_LOADING]: (
    state: DigitalHumanState,
    loading: boolean
  ): void => {
    state.loading = loading;
  },
  [BOT_BACKGROUND]: (state: DigitalHumanState, payload: boolean): void => {
    state.bot_background = payload;
  },
  [DIGITAL_HUMAN_SETTING]: (
    state: DigitalHumanState,
    payload: DigitalHumanSetting
  ): void => {
    state.bot_setting = payload;
  },
  [HYGEN_SESSION_ID]: (
    state: DigitalHumanState,
    payload: string | null
  ): void => {
    state.hygen_session_id = payload;
  },
  [HYGEN_SESSION_INFO]: (
    state: DigitalHumanState,
    payload: any | null
  ): void => {
    state.hygen_session_info = payload;
  },
  [HYGEN_RENDER_ID]: (state: DigitalHumanState, payload: number): void => {
    state.hygen_render_id = payload;
  },
  [HYGEN_PEER_CONNECTION]: (
    state: DigitalHumanState,
    payload: RTCPeerConnection | null
  ): void => {
    state.hygen_peer_connection = payload;
  },
  [HYGEN_SESSION_ERROR]: (
    state: DigitalHumanState,
    payload: string | null
  ): void => {
    state.hygen_session_error = payload;
  },
  [SESSION_INITIALIZED_SUCCESSFULLY]: (
    state: DigitalHumanState,
    payload: boolean
  ): void => {
    state.session_initialized_successfully = payload;
  }
};
